/**
 * Welle 9 (pre85c): Bild-Upload-Helfer. Skaliert clientseitig herunter, damit die
 * base64-Payloads klein bleiben (Body-Limit + DB-Größe).
 */
function loadImage(file: File): Promise<{ img: HTMLImageElement; revoke: () => void }> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => resolve({ img, revoke: () => URL.revokeObjectURL(url) });
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Bild konnte nicht geladen werden.')); };
    img.src = url;
  });
}

/** Logo: max 512px, PNG (Transparenz bleibt erhalten). SVG wird unverändert übernommen. */
export async function fileToLogoDataUrl(file: File): Promise<string> {
  if (file.type === 'image/svg+xml') {
    return await new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(String(r.result));
      r.onerror = () => rej(new Error('SVG konnte nicht gelesen werden.'));
      r.readAsDataURL(file);
    });
  }
  const { img, revoke } = await loadImage(file);
  const scale = Math.min(1, 512 / Math.max(img.width, img.height));
  const w = Math.max(1, Math.round(img.width * scale));
  const h = Math.max(1, Math.round(img.height * scale));
  const c = document.createElement('canvas');
  c.width = w; c.height = h;
  c.getContext('2d')!.drawImage(img, 0, 0, w, h);
  revoke();
  return c.toDataURL('image/png');
}

/** Hintergrund: max 1280px, JPEG (klein). */
export async function fileToBackgroundDataUrl(file: File, maxW = 1280): Promise<string> {
  const { img, revoke } = await loadImage(file);
  const scale = Math.min(1, maxW / img.width);
  const w = Math.max(1, Math.round(img.width * scale));
  const h = Math.max(1, Math.round(img.height * scale));
  const c = document.createElement('canvas');
  c.width = w; c.height = h;
  c.getContext('2d')!.drawImage(img, 0, 0, w, h);
  revoke();
  return c.toDataURL('image/jpeg', 0.85);
}
